var map = {
	"./juan-cocina.mp4": 7652,
	"./juan-consulta.mp4": 1810,
	"./juan-hospital.mp4": 3201,
	"./juan-salon.mp4": 5679,
	"./mute-blue.mp4": 8172,
	"./mute-green.mp4": 7375,
	"./mute-orange.mp4": 1138,
	"./mute-red.mp4": 7693,
	"./mute-violet.mp4": 635,
	"./video-1-rojo.mp4": 357,
	"./video-2-rojo.mp4": 7015,
	"./video-3-violet.mp4": 8544,
	"./video-4-blue.mp4": 9190,
	"./video-5-green.mp4": 8169,
	"./video-6-orange.mp4": 2803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2772;